import { BaseEntity } from './shared/baseEntity';

export const Account = ({
  companyIds,
  keyCloakIdentity,
  id,
  isActive
}) => {
  return Object.assign({
    companyIds: companyIds,
    keyCloakIdentity: KeyCloakIdentity(keyCloakIdentity),
  }, BaseEntity(id, isActive));
};

export const KeyCloakIdentity = ({
  userId,
  email,
  username,
  firstName,
  lastName
}) => {
  return Object.assign({
    userId,
    email,
    username,
    firstName,
    lastName
  });
};



// WEBPACK FOOTER //
// ./src/models/account.js